import React, {FC} from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Grid,
  TextField,
  FormHelperText,
  DialogActions,
  Button, Box,
} from '@material-ui/core';
import {useForm} from 'react-hook-form';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {ProviderList} from '../../providers/interfaces';
import RonadIcons from '../../../components/iconComponent';

interface Props {
  handleClose: () => void;
  open: boolean;
  submitProvider: (values: ProviderList) => void;
  loading: boolean;
  providerName: string | null;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(2),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
  }),
);

const ProviderModal: FC<Props> = ({handleClose, open, submitProvider, loading, providerName}: Props): React.ReactElement => {
  const {handleSubmit, errors, register} = useForm();
  const classes = useStyles();

  const submitFrom = (values: ProviderList) => {
    submitProvider(values);
  };

  return (
    <Dialog fullWidth
            onClose={handleClose} aria-labelledby="responsive-dialog-title" open={open}>
      <form onSubmit={handleSubmit(submitFrom)}>
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleClose}
            >
              <RonadIcons name="times"  size={0.8}/>
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <RonadIcons name='user'
              size={4}
              className='text-primary'
            />
          </div>
          <Grid container spacing={3}>
            <Grid container item xs={6} alignItems='flex-end'>
              <div className={classes.item}>
            <span className={classes.label}>
              <RonadIcons name='user'
                size={1}
              />
            </span>

                <div style={{width: '100%'}}>
                  <TextField
                    type="text"
                    fullWidth
                    id="name"
                    name="name"
                    defaultValue={providerName ? providerName : ''}
                    label="نام تامین‌کننده"
                    inputRef={register({
                      required: true,
                    })}
                    error={errors.name && true}
                  />
                  <FormHelperText error focused>
                    {errors.name && 'نام تامین‌کننده الزامی میباشد'}
                  </FormHelperText>
                </div>
              </div>
            </Grid>
            <Grid container item xs={6} alignItems='flex-end'>
              <div className={classes.item}>
                <span className={classes.label}>
                  <RonadIcons name='key'/>
                </span>

                <div style={{width: '100%'}}>
                  <TextField
                    type="text"
                    fullWidth
                    id="code"
                    name="code"
                    label="کد تامین‌کننده"
                    inputRef={register({
                      required: true,
                      pattern: /^[A-Za-z\d\-_]+$/,
                    })}
                    error={errors.code && true}
                  />
                  <FormHelperText error focused>
                    {errors.code && 'کد تامین‌کننده الزامی میباشد'}
                  </FormHelperText>
                </div>
              </div>
            </Grid>
          </Grid>
          <Box mb={3} />
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                type='submit'
                variant="contained"
                color="secondary"
                size="large"
                disabled={loading}
              >
                {`افزودن تامین‌کننده`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                onClick={handleClose}
                variant="contained"
                size="large"
              >
                {`انصراف`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ProviderModal;
